import AdminType from './AdminType'

const adminReducer = (state, action) => {
  switch (action.type) {
    case AdminType.GET_ADMINS:
      return {
        ...state,
        admins: action.payload,
        loading: false,
      }
    case AdminType.GET_ADMIN:
      return {
        ...state,
        admin: action.payload,
        loading: false,
      }
    case AdminType.CREATE_ADMIN:
      return {
        ...state,
        admin: action.payload,
        loading: false,
      }
    case AdminType.UPDATE_ADMIN:
      return {
        ...state,
        admin: action.payload,
        loading: false,
      }
    case AdminType.DELETE_ADMIN:
      return {
        ...state,
        loading: false,
      }
    case AdminType.GET_OVERVIEW_REPORTS:
      return {
        ...state,
        overview: action.payload,
        loading: false,
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: true,
      }
    default:
      return state
  }
}

export default adminReducer
